// Packaging items have no server-computed availability field (unlike kitchen
// inventory) — quantity/reorderThreshold are enough to derive the same kind
// of label client-side.
export function getPackagingStockLevel(
  quantity: number,
  reorderThreshold: number
): { label: string; color: 'success' | 'warning' | 'error' } {
  if (quantity <= 0) {
    return { label: 'out of stock', color: 'error' };
  }

  if (quantity <= reorderThreshold) {
    return { label: 'low stock', color: 'warning' };
  }

  return { label: 'in stock', color: 'success' };
}
